import { Injectable } from '@angular/core';

import { AbstractAsyncTaskReport } from './abstract-async-task.report';
import { ITask } from './async-task-constants';

@Injectable({
  providedIn: 'root'
})
export class ProviderTraceabilityBulkUpdateFinanceReport extends AbstractAsyncTaskReport {

  public generate(task: ITask): string {
    if (task.status === 'success') {
      return this.formatBulkUpdateTraceabilitiesSuccess(task.detail);

    } else {
      let htmlDetail = `<div>Échec de la mise à jour en masse des données financières des services fournisseurs.<br></div>`;
      htmlDetail += this.formatOnlyStructureAndContentImportError(task.detail);
      return htmlDetail;
    }
  }

  protected formatBulkUpdateTraceabilitiesSuccess(detail): string {
    let successString = '<div>Mise à jour en masse des données financières des services fournisseurs réussie.<br></div><ul>';
    if (detail.length > 0) {
      detail.forEach(({ id, code }) => {
        successString += `<li>Service : <a href="#/provider-traceabilities/detail/${id}">${code}</a></li>`;
      });
      successString += '</ul>';
    } else {
      successString = '<div>Aucun service mis à jour</div></ul>';
    }
    return successString;
  }

}
